"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TeamsIntegrationModalMetadataStep = void 0;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _TeamsIntegrationModalMetadataForm = require("../TeamsIntegrationModalMetadataForm");
var _TeamsIntegrationTreeView = require("../TeamsIntegrationTreeView");
var _TeamsAndChannelsContext = require("@/context/TeamsAndChannelsContext");
var _useTeamsFiles2 = require("@/hooks/useTeamsFiles");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var TeamsIntegrationModalMetadataStep = exports.TeamsIntegrationModalMetadataStep = function TeamsIntegrationModalMetadataStep() {
  var _useTeamsFiles = (0, _useTeamsFiles2.useTeamsFiles)(),
    getAllSelectedFiles = _useTeamsFiles.getAllSelectedFiles,
    updateTeamsFile = _useTeamsFiles.updateTeamsFile;
  var _useTeamsAndChannels = (0, _TeamsAndChannelsContext.useTeamsAndChannels)(),
    teamsFiles = _useTeamsAndChannels.teamsFiles;
  var _useState = (0, _react.useState)(""),
    _useState2 = _slicedToArray(_useState, 2),
    fileCategory = _useState2[0],
    setFileCategory = _useState2[1];
  var _useState3 = (0, _react.useState)(""),
    _useState4 = _slicedToArray(_useState3, 2),
    metadata = _useState4[0],
    setMetadata = _useState4[1];
  var handleFileCategoryChange = function handleFileCategoryChange(category) {
    setFileCategory(category);

    // Get all files that have selected = true
    var selectedFiles = getAllSelectedFiles();

    // Update the category of all selected files
    var _iterator = _createForOfIteratorHelper(selectedFiles),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var file = _step.value;
        var categoryArray = category ? [category] : null;
        updateTeamsFile(file.id, {
          category: categoryArray
        });
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  };
  var handleMetadataChange = function handleMetadataChange(metadata) {
    setMetadata(metadata);

    // Get all files that have selected = true
    var selectedFiles = getAllSelectedFiles();

    // Update the metadata of all selected files
    var _iterator2 = _createForOfIteratorHelper(selectedFiles),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var file = _step2.value;
        updateTeamsFile(file.id, {
          metadata: metadata
        });
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  };
  (0, _react.useEffect)(function () {
    var selectedFiles = getAllSelectedFiles();
    if (selectedFiles.length === 0) {
      setFileCategory("");
      setMetadata("");
      return;
    }

    // Validate categories
    var categories = selectedFiles.map(function (file) {
      var _file$category$, _file$category;
      return (_file$category$ = (_file$category = file.category) === null || _file$category === void 0 ? void 0 : _file$category[0]) !== null && _file$category$ !== void 0 ? _file$category$ : "";
    });
    var uniqueCategories = _toConsumableArray(new Set(categories));
    if (uniqueCategories.length === 1) {
      // All have the same category
      setFileCategory(uniqueCategories[0]);
    } else {
      // There are different categories
      setFileCategory("");
    }

    // Validate metadata
    var metadatas = selectedFiles.map(function (file) {
      var _file$metadata;
      return (_file$metadata = file.metadata) !== null && _file$metadata !== void 0 ? _file$metadata : "";
    });
    var uniqueMetadatas = _toConsumableArray(new Set(metadatas));
    if (uniqueMetadatas.length === 1) {
      // All have the same metadata
      setMetadata(uniqueMetadatas[0]);
    } else {
      // There are different metadatas
      setMetadata("");
    }
  }, [teamsFiles, getAllSelectedFiles]);
  return /*#__PURE__*/_react["default"].createElement(_material.Box, {
    display: "flex",
    sx: {
      width: "100%"
    }
  }, /*#__PURE__*/_react["default"].createElement(_TeamsIntegrationTreeView.TeamsIntegrationTreeView, null), /*#__PURE__*/_react["default"].createElement(_TeamsIntegrationModalMetadataForm.TeamsIntegrationModalMetadataForm, {
    handleFileCategoryChange: handleFileCategoryChange,
    handleMetadataChange: handleMetadataChange,
    fileCategory: fileCategory,
    metadata: metadata
  }));
};